import axios from "axios";
import { getApiErrorMessage } from "./error";
import { clearSession, getSessionToken } from "../utils/session";


const API = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  timeout: 15000,
});

API.interceptors.request.use((req) => {
  const token = getSessionToken();

  if (token) {
    req.headers.Authorization = `Bearer ${token}`;
  }

  return req;
});

API.interceptors.response.use(
  (response) => response,
  (error) => {
    error.userMessage = getApiErrorMessage(error);

    if (error.response?.status === 401) {
      clearSession();
      if (typeof window !== "undefined" && window.location.pathname !== "/") {
        window.location.href = "/";
      }
    }
    return Promise.reject(error);
  }
);

export default API;
